import isEqual from 'lodash/isEqual';

export const isPropsEqual = (prevProps: unknown, nextProps: unknown): boolean => {
  return isEqual(prevProps, nextProps);
};
